import withAPIAction from 'helpers/withAPIAction'
import {
  PaymentReq,
  PaymentStatReq,
  TopSaleReq,
  SupplierDashboardReq,
  ReturnDashboardReq,
  TerminalProfitReq,
} from './types'
import {
  getPaymentDashboardAction,
  getPaymentStatDashboardAction,
  getTopSaleDashboardAction,
  getSupplierDashboardAction,
  getReturnSummaryDashboardAction,
  getTerminalProfitAction,
} from './actions'
import { APIPath } from 'services/APIPath'
import { appConfig } from 'config'
import { getRequestString } from 'helpers/format'

export const paymentDashboardAPI = (data: PaymentReq, token: string) => {
  return withAPIAction<PaymentReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.paymentDashboard}?${getRequestString(data)}`,
    data,
    token,
  })(getPaymentDashboardAction)
}

export const paymentStatDashboardAPI = (data: PaymentStatReq, token: string) => {
  return withAPIAction<PaymentStatReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.paymentStatDashboard}?${getRequestString(data)}`,
    data,
    token,
  })(getPaymentStatDashboardAction)
}

export const topSaleDashboardAPI = (data: TopSaleReq, token: string) => {
  return withAPIAction<TopSaleReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.topSaleDashboard}?${getRequestString(data)}`,
    data,
    token,
  })(getTopSaleDashboardAction)
}

export const getSupplierDashboardAPI = (data: SupplierDashboardReq, token: string) => {
  return withAPIAction<SupplierDashboardReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.supplierDashboard}?${getRequestString(data)}`,
    data,
    token,
  })(getSupplierDashboardAction)
}

export const getReturnDashboardAPI = (data: ReturnDashboardReq, token: string) => {
  return withAPIAction<ReturnDashboardReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.returnDashboard}?${getRequestString(data)}`,
    data,
    token,
  })(getReturnSummaryDashboardAction)
}

export const getTerminalProfitAPI = (data: TerminalProfitReq, token: string) => {
  return withAPIAction<TerminalProfitReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.terminalProfitDashboard}?${getRequestString(data)}`,
    data,
    token,
  })(getTerminalProfitAction)
}
